import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearDistributorCurrentStockDetails,
  clearDistributorCurrentStockFormDetails,
  setDistributorCurrentStockFormDetails,
} from "../reports/reportsSlice";
import { clearAccountList } from "../account/accountSlice";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import ShadowCard from "../../components/common/ShadowCard";
import { getDistributorCurrentStockReportByID } from "../reports/services/reports.services";
import { Typography } from "@progress/kendo-react-common";
import { getAllAccountIncremental } from "../account/services/account.services";
import FormIncrementalSearch from "../../components/formFields/FormIncrementalSearch";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import AlertBox from "../../components/common/AlertBox";
import { Button } from "@progress/kendo-react-buttons";
import {
  checkAcessRights,
  formatIndianNumber,
  formatIndianNumberForQty,
} from "../../_helper/helper";
import { EXCEL_EXPORT_ACCESS, PRINT_ACCESS } from "../../_contstants/common";
import Logo from "../../assets/Images/logo.png";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IItemGroup } from "../ItemGroup/itemgroupModel";
import { IItemCategory } from "../Item Category/ItemCategoryModel";
import { getAllItemIncremental } from "../Item/services/item.services";
import { findAllActiveItemGroup } from "../ItemGroup/services/itemgroup.services";
import { findAllActiveItemCategory } from "../Item Category/services/Itemcategory.services";
import { IItem } from "../Item/itemModel";

const DistributorCurrentStock: React.FC = () => {
  const gridRef = React.useRef<any>(null);
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const ItemList = useAppSelector((state) => state.item.ItemList);
  const DistributorCurrentStockFormDetails = useAppSelector(
    (state) => state.reports.DistributorCurrentStockFormDetails
  );
  const DistributorCurrentStockDetails = useAppSelector(
    (state) => state.reports.DistributorCurrentStockDetails
  );
  const ItemGroupList = useAppSelector(
    (state) => state.itemgroup.ItemGroupList
  )?.filter((item: any) => item.isdisplaysalesorder);
  const ItemCategoryList = useAppSelector(
    (state) => state.itemCategory.ItemCategoryList
  );
  const [initialValue, setInitialValue] = useState<any>({});
  const [formKey, setFormKey] = useState<any>(1);

  useEffect(() => {
    setInitialValue({
      ...DistributorCurrentStockFormDetails,
      from_date: DistributorCurrentStockFormDetails?.from_date
        ? moment(
            DistributorCurrentStockFormDetails?.from_date,
            "YYYY-MM-DD"
          ).toDate()
        : null,
      to_date: DistributorCurrentStockFormDetails?.to_date
        ? moment(
            DistributorCurrentStockFormDetails?.to_date,
            "YYYY-MM-DD"
          ).toDate()
        : null,
    });
    setFormKey(formKey + 1);
  }, [DistributorCurrentStockFormDetails]);

  useEffect(() => {
    dispatch(findAllActiveItemGroup());
    dispatch(findAllActiveItemCategory());

    return () => {
      dispatch(clearDistributorCurrentStockDetails());
      dispatch(clearAccountList());
      dispatch(clearDistributorCurrentStockFormDetails());
    };
  }, []);

  const handleVendorSearchChange = useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllAccountIncremental(search));
      formRenderProps.onChange(field, {
        value: result.payload,
      });
    },
    [dispatch]
  );

  const handleSubmit = (values: any) => {
    const payload = {
      account_id: values?.account_id ? values?.account_id : null,
      from_date: values?.from_date
        ? moment(values?.from_date).format("YYYY-MM-DD")
        : "",
      to_date: values?.to_date
        ? moment(values?.to_date).format("YYYY-MM-DD")
        : "",
      item_id: values?.item_id ? values?.item_id : null,
      item_group_id: values?.item_group_id ? values?.item_group_id : null,
      item_category_id: values?.item_category_id
        ? values?.item_category_id
        : null,
    };
    const setPayload = {
      ...payload,
      vendor_options: values?.vendor_options || [],
      item_options: values?.item_options || [],
    };
    dispatch(getDistributorCurrentStockReportByID(payload));
    dispatch(setDistributorCurrentStockFormDetails(setPayload));
  };

  return (
    <div>
      <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <ShadowCard>
            <Form
              key={formKey}
              initialValues={initialValue}
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "100%" }}>
                  <GridLayout
                    style={{ marginRight: 20 }}
                    gap={{ rows: 10, cols: 10 }}
                    cols={[
                      { width: "33.33%" },
                      { width: "33.33%" },
                      { width: "33.33%" },
                    ]}
                  >
                    <GridLayoutItem colSpan={3}>
                      <Typography.h4
                        style={{ marginBottom: 0, marginLeft: "3px" }}
                      >
                        Distributor Current Stock Report
                      </Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="account_id"
                        label="Distributor"
                        placeholder="Type here to search distributor..."
                        component={FormIncrementalSearch}
                        validator={requiredValidator}
                        astrike={true}
                        fetchIncrementalData={(search: any) =>
                          handleVendorSearchChange(
                            search,
                            `vendor_options`,
                            formRenderProps
                          )
                        }
                        options={
                          formRenderProps
                            .valueGetter("vendor_options")
                            ?.map((item: any) => {
                              return {
                                value: item.id,
                                label: item.account_name,
                              };
                            }) || []
                        }
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name="from_date"
                        label="From Date"
                        format="dd/MM/yyyy"
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperStyle={{ width: "100%" }}
                        name="to_date"
                        label="To Date"
                        format="dd/MM/yyyy"
                        minDate={
                          moment(
                            formRenderProps.valueGetter("from_date")
                          ).toDate() || new Date(1900, 0, 1)
                        }
                        astrike={true}
                        component={FormDatePicker}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="item_group_id"
                        label="Product Group Name"
                        placeholder="Product Group Name"
                        component={FormSelectionField}
                        options={ItemGroupList?.map((itemgroup: IItemGroup) => {
                          return {
                            value: itemgroup?.id,
                            label: itemgroup?.item_group,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="item_category_id"
                        label="Product Category Name"
                        placeholder="Product Category Name"
                        component={FormSelectionField}
                        options={ItemCategoryList?.map(
                          (itemCategory: IItemCategory) => {
                            return {
                              value: itemCategory?.id,
                              label: itemCategory?.item_category,
                            };
                          }
                        )}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="w-100"
                        name="item_id"
                        label="Product Name"
                        placeholder="Type here to search item..."
                        component={FormIncrementalSearch}
                        fetchIncrementalData={(search: any) =>
                          !formRenderProps.valueGetter("item_group_id") ||
                          formRenderProps.valueGetter("item_group_id") === null
                            ? dispatch(
                                getAllItemIncremental({
                                  search: search,
                                })
                              )
                            : dispatch(
                                getAllItemIncremental({
                                  search: search,
                                  item_group_id:
                                    formRenderProps.valueGetter(
                                      "item_group_id"
                                    ),
                                })
                              )
                        }
                        //   loading={itemLoading}
                        options={ItemList?.map((item: IItem) => {
                          return {
                            value: item?.id,
                            label: item?.product_name,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={3} style={{ textAlign: "end" }}>
                      <ButtonWithLoading
                        label={"View"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </ShadowCard>
          {loading ? (
            <LoadingPanel gridRef={gridRef} />
          ) : (
            DistributorCurrentStockDetails &&
            DistributorCurrentStockDetails?.length > 0 && (
              <ShadowCard style={{ marginTop: 10 }}>
                <DistributorCurrentStockGridCommponent />
              </ShadowCard>
            )
          )}
        </GridLayoutItem>
      </GridLayout>
    </div>
  );
};

const DistributorCurrentStockGridCommponent: React.FC = () => {
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );

  //   const loading = useAppSelector((state) => state.reports.loading);
  const DistributorCurrentStockDetails = useAppSelector(
    (state) => state.reports.DistributorCurrentStockDetails
  );
  const DistributorCurrentStockFormDetails = useAppSelector(
    (state) => state.reports.DistributorCurrentStockFormDetails
  );
  let grandTotalClosingQty = 0;
  let grandTotalDifferenceQty = 0;
  DistributorCurrentStockDetails &&
    DistributorCurrentStockDetails?.length > 0 &&
    DistributorCurrentStockDetails?.map((item: any) => {
      item?.distributer_stock_list &&
        item?.distributer_stock_list?.length > 0 &&
        item?.distributer_stock_list?.map((subItem: any) => {
          grandTotalClosingQty += +subItem?.closing_qty;
          grandTotalDifferenceQty += +subItem?.difference_qty;
        });
    });

  const printTable = (DistributorCurrentStockDetails: any) => {
    let printbuttons = document.querySelector(
      ".printbuttons"
    ) as HTMLElement | null;
    let report_container = document.querySelector(
      ".report-container"
    ) as HTMLElement | null;

    if (printbuttons) printbuttons.style.display = "none";
    if (report_container) report_container.style.padding = "20px 0";

    const data: any[] = DistributorCurrentStockDetails;
    let tableRows = data.length;
    let maxRows = tableRows;
    let pageCount = Math.ceil(tableRows / maxRows);
    let content = "";

    for (let i = 0; i < pageCount; i++) {
      content += '<div class="print-page">';
      //   content += `<div class="page-header">Page ${i + 1}</div>`;
      content +=
        '<table class="table table-bordered" style="font-size:10px;margin-bottom:30px;">';
      content += "<tr>";
      content += `<td rowSpan="3" style="width:15%" ><img src="${Logo}" width="100%" /></td>`;
      content +=
        '<td colSpan="2" style="text-align: center;font-size: 14px;font-weight: 600;color: gray;">Harihar Foods Pvt Ltd.</td>';
      content += "</tr>";
      content += "<tr>";
      content +=
        '<td colSpan="2"><h3 style="margin:0;">Distributor Current Stock Report</h3></td>';
      content += "</tr>";
      content += "<tr>";
      content += `<td style="border-right:1px solid white;">${
        DistributorCurrentStockDetails &&
        DistributorCurrentStockDetails?.length > 0 &&
        DistributorCurrentStockDetails[0]?.account_name
      }</td>`;
      content += `<td style="text-align:end;">Page : ${i + 1}</td>`;
      content += "</tr>";

      content += "</table>";

      content += '<table class="table table-bordered" style="font-size:10px;">';
      content += '<thead style="background:lightgray;">';
      content += "<tr>";
      content += '<th style="width:40px;">Sr. No.</th>';
      content += "<th>Item Name</th>";
      content += "<th>Opening Qty</th>";
      content += "<th>Distributor Inward Qty</th>";
      content += "<th>Distributor Inward Free Qty</th>";
      content += "<th>Retailer Sales Qty</th>";
      content += "<th>Retailer Sales Free Qty</th>";
      content += "<th>Sales Return Qty</th>";
      content += "<th>Sales Return Free Qty</th>";
      content += "<th>Difference Qty</th>";
      content += "<th>Closing Qty</th>";
      content += "</tr>";
      content += "</thead>";
      content += "<tbody>";

      if (data && data?.length > 0) {
        data?.forEach((item: any) => {
          let totalClosingQty = 0;
          let totalDifferenceQty = 0;
          content += `<tr style="background:whitesmoke;">`;
          content += `<td colSpan="6" style="font-weight:600;">${item.item_group}</td>`;
          content += `</tr>`;

          if (
            item?.distributer_stock_list &&
            item?.distributer_stock_list?.length > 0
          ) {
            item.distributer_stock_list?.forEach(
              (subitem: any, index: number) => {
                totalClosingQty += +subitem?.closing_qty;
                totalDifferenceQty += +subitem?.difference_qty;
                content += `<tr>`;
                content += `<td style="text-align:center;">${index + 1}</td>`;
                content += `<td>${subitem?.product_name}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.opening_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.sales_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.sales_free_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.retailer_sales_item_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.retailer_sales_free_item_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.sales_return_item_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.sales_return_free_item_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.difference_qty || 0
                )}</td>`;
                content += `<td style="text-align:end;">${formatIndianNumberForQty(
                  subitem?.closing_qty || 0
                )}</td>`;
                content += "</tr>";
              }
            );
          }

          content += `<tr style="text-align:end; font-weight:600;">`;
          content += `<td colSpan="9">Total</td>`;
          content += `<td>${formatIndianNumber(totalDifferenceQty)}</td>`;
          content += `<td>${formatIndianNumber(totalClosingQty)}</td>`;
          content += `</tr>`;
        });
      }
      content += `<tr style="text-align:end; font-weight:600; background:whitesmoke;">`;
      content += `<td colSpan="9">Grand Total</td>`;
      content += `<td>${formatIndianNumber(grandTotalDifferenceQty)}</td>`;
      content += `<td>${formatIndianNumber(grandTotalClosingQty)}</td>`;
      content += `</tr>`;

      content += "</tbody>";
      content += "</table>";

      content += "</div>";
    }

    let printWindow = window.open("", "_blank");
    if (!printWindow) {
      console.error("Failed to open print preview window.");
      return;
    }
    printWindow.document.write(`
      <html>
      <head>
        <title>Print Preview</title>
        <style>
          @page { margin: 1cm; }
          .print-page { page-break-after: always; }
          .table-bordered { width: 100%; border-collapse: collapse; }
          .table-bordered th, .table-bordered td { border: 1px solid black; padding: 8px; }
          body { font-family: Arial, sans-serif; max-width:1140px; margin: 0 auto;}
        </style>
      </head>
      <body>
        ${content}
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();

    if (printbuttons) printbuttons.style.display = "block";
    if (report_container) report_container.style.padding = "20px 10px";
  };

  const handleExportExcel = () => {
    /*===*===* YOUR TABLE *===*===*/
    const table = document.querySelector(
      ".currentstock-print-table"
    ) as HTMLTableElement;
    if (!table) return;
    const workbook = new ExcelJS.Workbook();
    /*===*===* YOUR SHEET NAME *===*===*/
    const worksheet = workbook.addWorksheet(
      `${
        (DistributorCurrentStockDetails &&
          DistributorCurrentStockDetails?.length > 0 &&
          DistributorCurrentStockDetails[0]?.account_name) ||
        ""
      }`
    );
    const rows = Array.from(table.querySelectorAll("tr"));
    let excelRowIndex = 1; // Excel row index (1-based)
    const occupiedCells: Record<string, boolean> = {}; // Track occupied cells
    const colWidths: number[] = [];

    rows.forEach((row, rowIndex) => {
      const cells = Array.from(row.children) as HTMLTableCellElement[];
      let colIndex = 1; // Reset to first column for each row

      cells.forEach((cell) => {
        const cellContent = cell.textContent?.trim() || "";
        const cellLength = cellContent.length;
        const colSpan = cell.colSpan || 1;
        const rowSpan = cell.rowSpan || 1;

        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
        /*===*===* Find the next available column (skip occupied columns) *===*===*/
        while (occupiedCells[`${excelRowIndex}-${colIndex}`]) {
          colIndex++;
        }
        /*===*===* SET VALUE AND TABLE STYLE *===*===*/
        const excelCell = worksheet.getRow(excelRowIndex).getCell(colIndex);
        const numericValue = Number(cellContent.replace(/,/g, ""));
        if (
          !isNaN(numericValue) &&
          cellContent.replace(/,/g, "").match(/^\d+(\.\d+)?$/)
        ) {
          excelCell.value = numericValue; // Store as a real number
        } else {
          excelCell.value = cellContent; // Store as text
        }
        // excelCell.value = cellContent;
        excelCell.alignment = { horizontal: "center", vertical: "middle" };
        excelCell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };

        /*===*===* HEADER STYLE *===*===*/
        if (rowIndex === 0) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ffabab" },
          };
        }

        /*===*===* HANDEL colSpan AND rowSpan *===*===*/
        if (colSpan > 1 || rowSpan > 1) {
          const startCell = worksheet
            .getRow(excelRowIndex)
            .getCell(colIndex).address;
          const endCell = worksheet
            .getRow(excelRowIndex + rowSpan - 1)
            .getCell(colIndex + colSpan - 1).address;

          worksheet.mergeCells(`${startCell}:${endCell}`);
          // Mark merged cells as occupied
          for (let r = 0; r < rowSpan; r++) {
            for (let c = 0; c < colSpan; c++) {
              occupiedCells[`${excelRowIndex + r}-${colIndex + c}`] = true;
            }
          }
        }
        // FOR TOTAL
        if (cells.length === 3) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFCE1B" },
          };
        }
        // FOR GROUP HEADER
        if (cells.length === 1) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "aff6af" },
          };
        }
        /*===*===* LAST ROW STYLE *===*===*/
        if (rowIndex === rows.length - 1) {
          excelCell.font = { bold: true };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "D9E1F2" },
          };
        }
        colIndex += colSpan;
      });

      excelRowIndex++; // Move to next row
    });

    worksheet.columns = colWidths.map((width) => ({ width }));
    /*===*===* SAVE THE FILE  *===*===*/
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(
        blob,
        `Current Stock Report-${
          (DistributorCurrentStockDetails &&
            DistributorCurrentStockDetails?.length > 0 &&
            DistributorCurrentStockDetails[0]?.account_name) ||
          ""
        }-${moment().format("DD-MM-YYYY_hh-mm-A")}.xlsx`
      );
    });
  };

  // const handleExportExcel = () => {
  //   const wb = XLSX.utils.book_new();
  //   const ws = XLSX.utils.table_to_sheet(
  //     document.querySelector(".currentstock-print-table")
  //   );
  //   XLSX.utils.book_append_sheet(wb, ws, "DistributorCurrentStockReport");

  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });
  //   saveAs(
  //     data,
  //     `${
  //       (DistributorCurrentStockDetails &&
  //         DistributorCurrentStockDetails?.length > 0 &&
  //         DistributorCurrentStockDetails[0]?.account_name) ||
  //       ""
  //     } Current Stock Report`
  //   );
  // };

  return (
    <>
      {DistributorCurrentStockDetails &&
      DistributorCurrentStockDetails?.length > 0 ? (
        <GridLayout
          //   style={{ marginRight: 30 }}
          gap={{ rows: 10, cols: 10 }}
          cols={[{ width: "100%" }]}
        >
          <GridLayoutItem className="d-flex justify-content-between align-items-center">
            <Typography.h4 className="m-0">
              Distributor Current Stock List{" "}
              {(DistributorCurrentStockFormDetails?.from_date ||
                DistributorCurrentStockFormDetails?.to_date) && (
                <span style={{ fontSize: 13 }}>
                  {"("}
                  {DistributorCurrentStockFormDetails?.from_date
                    ? moment(
                        DistributorCurrentStockFormDetails?.from_date,
                        "YYYY-MM-DD"
                      ).format("DD/MM/YYYY")
                    : ""}
                  {DistributorCurrentStockFormDetails?.from_date &&
                    DistributorCurrentStockFormDetails?.to_date &&
                    " - "}
                  {DistributorCurrentStockFormDetails?.to_date
                    ? moment(
                        DistributorCurrentStockFormDetails?.to_date,
                        "YYYY-MM-DD"
                      ).format("DD/MM/YYYY")
                    : ""}
                  {")"}
                </span>
              )}
              {/* {DistributorCurrentStockDetails?.date && (
                <span style={{ fontSize: 13 }}>
                  {"("}
                  {moment(
                    DistributorCurrentStockDetails?.date,
                    "YYYY-MM-DD"
                  ).format("DD/MM/YYYY")}
                  {")"}
                </span>
              )} */}
            </Typography.h4>
            <div>
              {isPrintAccess && (
                <Button
                  style={{ marginRight: 5 }}
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={() => printTable(DistributorCurrentStockDetails)}
                >
                  Print
                </Button>
              )}
              {isExcelAccess && (
                <Button
                  type="button"
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={handleExportExcel}
                  style={{ marginLeft: 5 }}
                >
                  Excel Export
                </Button>
              )}
            </div>
          </GridLayoutItem>
          <GridLayoutItem>
            <table
              cellSpacing={1}
              cellPadding={2}
              className="table table-bordered w-100  currentstock-print-table"
              style={{ marginTop: 1 }}
            >
              <tr className="text-center fw-600" style={{ fontSize: 12 }}>
                <th style={{ width: "10%" }}>Sr No.</th>
                <th style={{ width: "18%" }}>Description Of Goods</th>
                <th style={{ width: "10%" }}>Opening Qty</th>
                <th style={{ width: "8%" }}>Distributor Inward Qty</th>
                <th style={{ width: "8%" }}>Distributor Inward Free Qty</th>
                <th style={{ width: "8%" }}>Retailer Sales Qty</th>
                <th style={{ width: "8%" }}>Retailer Sales Free Qty</th>
                <th style={{ width: "8%" }}>Sales Return Qty</th>
                <th style={{ width: "8%" }}>Sales Return Free Qty</th>
                <th style={{ width: "5%" }}>Difference Qty</th>
                <th style={{ width: "5%" }}>Closing Qty</th>
              </tr>
              {DistributorCurrentStockDetails &&
                DistributorCurrentStockDetails?.length > 0 &&
                DistributorCurrentStockDetails?.map((item: any) => {
                  let totalClosingQty = 0;
                  let totalDifferenceQty = 0;
                  return (
                    <>
                      <tr style={{ background: "whitesmoke" }}>
                        <td
                          className="fw-600"
                          colSpan={11}
                          style={{ fontSize: 12 }}
                        >
                          {item?.item_group}
                        </td>
                      </tr>
                      {item?.distributer_stock_list &&
                        item?.distributer_stock_list?.length > 0 &&
                        item?.distributer_stock_list?.map(
                          (subitem: any, index: number) => {
                            totalClosingQty += +subitem?.closing_qty;
                            totalDifferenceQty += +subitem?.difference_qty;
                            return (
                              <tr>
                                <td className="text-center">{index + 1}</td>
                                <td>{subitem?.product_name}</td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.opening_qty || 0
                                  )}
                                </td>

                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.sales_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.sales_free_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.retailer_sales_item_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.retailer_sales_free_item_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.sales_return_item_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.sales_return_free_item_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.difference_qty || 0
                                  )}
                                </td>
                                <td className="text-end">
                                  {formatIndianNumberForQty(
                                    subitem?.closing_qty || 0
                                  )}
                                </td>
                              </tr>
                            );
                          }
                        )}
                      <tr className="text-end fw-600">
                        <td colSpan={9}>Total</td>
                        <td>{formatIndianNumber(totalDifferenceQty)}</td>
                        <td>{formatIndianNumber(totalClosingQty)}</td>
                      </tr>
                    </>
                  );
                })}
              <tr className="text-end fw-600" style={{ background: "#ffe1e1" }}>
                <td colSpan={9}>Grand Total</td>
                <td>{formatIndianNumber(grandTotalDifferenceQty)}</td>
                <td>{formatIndianNumber(grandTotalClosingQty)}</td>
              </tr>
            </table>
          </GridLayoutItem>
        </GridLayout>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default DistributorCurrentStock;
